export default __webpack_public_path__ + "static/media/six.ee8c052d.png";